export const IS_APPLE = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

export const controlOrMetaByCurrentKey = (e: KeyboardEvent): boolean => {
  // keyDown / keyUp したkeyの判別
  if (IS_APPLE) {
    return e.key === "Meta";
  } else {
    return e.key === "Control";
  }
};

export const whithControlOrMeta = (e: KeyboardEvent): boolean => {
  if (IS_APPLE) {
    return e.metaKey;
  } else {
    return e.ctrlKey;
  }
};

export const getPositionMouseOrTouch = (
  e: React.MouseEvent | React.TouchEvent
) => {
  if ("touches" in e) {
    return {
      y: e.touches[0]?.clientY || 0,
      x: e.touches[0]?.clientX || 0,
    };
  }
  return {
    y: e.pageY || 0,
    x: e.pageX || 0,
  };
};
